import script from "./cottonBotTalk.vue?vue&type=script&setup=true&lang=js"
export * from "./cottonBotTalk.vue?vue&type=script&setup=true&lang=js"

import "./cottonBotTalk.vue?vue&type=style&index=0&id=5fb640f7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fb640f7"]])

export default __exports__